import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22eba374"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", null, "Recently Accessed Records")
], -1))
const _hoisted_2 = { class: "records-holder" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Contacts", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" }, null, -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Properties", -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-house" }, null, -1))
const _hoisted_11 = { key: 2 }

import { ref, inject, computed } from "vue";
import { PropertySummary as PropertySummaryModel } from "@/types/properties/PropertySummary";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { ContactSummary as ContactSummaryModel } from "@/types/contacts/ContactSummary";
import { useRouter } from "vue-router";
import { RouteNames } from "@/router/RouteNames";
import { useRecentRecordsStore } from "@/stores/RecentRecordsStore";
import popoverBase from "../ui/popovers/popover-base.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'recent-records-popover',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * Indicates the target.
   * @type {string}
   * @required
   */
  target: {
    type: String,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes.
   * This is used to update the v-model variable in the parent component and control the visibility of the modal.
   * @event update:modelValue
   * @property {boolean} value - The updated state to reflect whether the modal should be shown or hidden.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();
const propertySummaryData = ref<PropertySummaryModel[]>([]);
const contactSummary = ref<ContactSummaryModel[]>([]);
const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const recentRecordsStore = useRecentRecordsStore();
const loading = ref(false);





const showPopOver = computed({
  get: () => props.modelValue,
  set: (value: Boolean) => emit("update:modelValue", value),
});

const popupDisplayed = async () => {
  // If we have opened the modal previously and fetched the recently accessed records from the store,
  // we will check to see if the data fetched from the store macthes the data we already have. If it
  // does, we does bother looping through the data and calling the getContactData, fetchPropertyData
  // functions or both.
  loading.value = true;
  await displayPropertyData();
  await displayContactsData();
  loading.value = false;
};

const displayContactsData = async () => {
  const contactRecords = await recentRecordsStore.readContactRecordsCookie();

  // We must reset these  as this prevents the same records arrays being displayed multiple times each time the modal is opened.
  contactSummary.value = [];

  // We cannot use the forEach array method asynchronously so we must use for loops to fetch each of the recent record's title.

  for (let i = 0; i < contactRecords.length; i++) {
    let fetchedContact: ContactSummaryModel | boolean = await getContactData(
      contactRecords[i],
    );

    if (fetchedContact) {
      contactSummary.value.push(fetchedContact);
    }
  }
};

const displayPropertyData = async () => {
  const propertyRecords = await recentRecordsStore.readPropertyRecordsCookie();

  propertySummaryData.value = [];

  for (let i = 0; i < propertyRecords.length; i++) {
    let fetchedProperty: PropertySummaryModel | boolean =
      await fetchPropertyData(propertyRecords[i]);

    if (fetchedProperty) {
      propertySummaryData.value.push(fetchedProperty);
    }
  }
};

const fetchPropertyData = async (id: number) => {
  try {
    return await apiClient.httpGet<PropertySummaryModel>(
      `app/properties/${id}/summary`,
    );
  } catch (err) {
    return false;
  }
};

const getContactData = async (id: number) => {
  try {
    return await apiClient.httpGet<ContactSummaryModel>(
      `app/contacts/${id}/summary`,
    );
  } catch (ex) {
    return false;
  }
};

const loadPropertyRecord = async (propertyId: number) => {
  showPopOver.value = false;
  router.push({
    name: RouteNames.PropertyPage,
    params: { propertyid: propertyId.toString() },
  });
};

/** Redirects the user to the contact page */
const loadContactRecord = async (contactId: number) => {
  showPopOver.value = false;
  router.push({
    name: RouteNames.ContactPage,
    params: { contactid: contactId.toString() },
  });
};

const showNoDataMessage = computed(
  () =>
    propertySummaryData.value.length == 0 && contactSummary.value.length == 0,
);

const height = computed(() => window.outerHeight);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(popoverBase, {
    modelValue: showPopOver.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showPopOver).value = $event)),
    target: props.target,
    width: "370px",
    height: `${height.value}px`,
    onPopupDisplayed: popupDisplayed,
    loading: loading.value
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_2, [
        (contactSummary.value.length > 0)
          ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
              _hoisted_4,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactSummary.value, (contact, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "record",
                  key: index,
                  onClick: ($event: any) => (loadContactRecord(contact.id))
                }, [
                  _hoisted_6,
                  _createElementVNode("span", null, _toDisplayString(contact.name), 1)
                ], 8, _hoisted_5))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (propertySummaryData.value.length > 0)
          ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propertySummaryData.value, (property, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "record",
                  key: index,
                  onClick: ($event: any) => (loadPropertyRecord(property.id))
                }, [
                  _hoisted_10,
                  _createElementVNode("span", null, _toDisplayString(property.address), 1)
                ], 8, _hoisted_9))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (showNoDataMessage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "There are no recently accessed records to display."))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "target", "height", "loading"]))
}
}

})